document.addEventListener('DOMContentLoaded', () => {
  const section = document.querySelector('.price-increases');

  if (!section) return;

  const searchInput = section.querySelector('[data-price-filter-search]');
  const statusInputs = section.querySelectorAll('[data-price-filter-status]');
  const manufacturerInputs = section.querySelectorAll('[data-price-filter-manufacturer]');
  const clearButton = section.querySelector('[data-price-clear-filters]');
  const entries = section.querySelectorAll('[data-price-entry]');

  function getCheckedValues(inputs) {
    return Array.from(inputs)
      .filter((input) => input.checked)
      .map((input) => input.value.toLowerCase());
  }

  function applyFilters() {
    const searchTerm = searchInput ? searchInput.value.trim().toLowerCase() : '';

    const selectedStatuses = getCheckedValues(statusInputs);
    const selectedManufacturers = getCheckedValues(manufacturerInputs);

    entries.forEach(entry => {
        const manufacturer = entry.dataset.priceManufacturer || '';
        const status = entry.dataset.priceStatus || '';

        const matchesSearch =
        !searchTerm || manufacturer.includes(searchTerm);

        const matchesStatus =
        selectedStatuses.length === 0 ||
        selectedStatuses.includes(status);

        const matchesManufacturer =
        selectedManufacturers.length === 0 ||
        selectedManufacturers.includes(manufacturer);

        entry.hidden = !(
        matchesSearch &&
        matchesStatus &&
        matchesManufacturer
        );
    });

    const mobileToggle = document.querySelector('[data-price-filters-toggle]');
    const filters = document.querySelector('.price-increases__filters');

    if (mobileToggle && filters) {
    mobileToggle.addEventListener('click', () => {
        filters.classList.toggle('is-open');
    });
    }

    const groups = section.querySelectorAll('.price-increases__group');

    groups.forEach(group => {
        const visibleRows = group.querySelectorAll(
            'tr[data-price-entry]:not([hidden]), article[data-price-entry]:not([hidden])'
        );

        const hasVisibleRows = visibleRows.length > 0;

        group.hidden = !hasVisibleRows;

        if (hasVisibleRows) {
            group.classList.add('is-visible');
        } else {
            group.classList.remove('is-visible');
        }
    });
  }

  if (searchInput) {
    searchInput.addEventListener('input', applyFilters);
  }

  statusInputs.forEach((input) => {
    input.addEventListener('change', applyFilters);
  });

  manufacturerInputs.forEach((input) => {
    input.addEventListener('change', applyFilters);
  });

  if (clearButton) {
    clearButton.addEventListener('click', () => {
      if (searchInput) searchInput.value = '';

      statusInputs.forEach((input) => {
        input.checked = input.value === 'Upcoming' || input.value === 'Live';
      });

      manufacturerInputs.forEach((input) => {
        input.checked = false;
      });

      applyFilters();
    });
  }

  applyFilters();
});